import React from 'react'

export default function CompanyLogo({ size = 'md', className = '' }) {
  const sizePixels = {
    xs: '35px',
    sm: '60px',
    md: '80px',
    lg: '120px'
  }

  const logoStyle = {
    height: sizePixels[size],
    width: 'auto',
    maxWidth: '100%',
    objectFit: 'contain'
  }

  return (
    <div className={`company-logo ${className}`}>
      <img 
        src="/vendviitor-logo.png" 
        alt="Vendviitor Logo" 
        style={logoStyle}
        className="img-fluid"
      />
    </div>
  )
}